/* eslint-disable react/prop-types */
import Cookies from 'js-cookie';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
// components
import { ApplyJobModal  , ApplyJobProvider }  from 'candidate/apply-job-proccess';

const JobCard = ({
  logo,
  slug,
  jobId,
  title,
  created,
  getData,
  min_exp,
  cat_slug,
  job_city,
  work_type,
  is_applied,
  onlyResume,
  salary_max,
  salary_min,
  company_name,
  salary_currency,
  onlyQuestionnaire,
}) => {
  const { t } = useTranslation('global');
  const userType = Cookies.get('user_type');

  const currencies = { 1: '₴', 2: '$', 3: '€' };

  const [openApplyJobModal, setOpenApplyJobModal] = useState(false);

  const handleJobView = e => {
    if (e.target.closest('button')) return;

    window.open(`/jobdescription/${slug}/${cat_slug}`, '_blank');
  };

  return (
    <>
      <div className='card Jcard' onMouseUp={e => handleJobView(e)} style={{ cursor: 'pointer' }}>
        <div className='card-body JcardBody'>
          <h2 title={title} className='h5 card-title JcardTitle homeJobs'>
            {title}
          </h2>
          <div className='JcardBodySection1 float-left' style={{ height: '26px' }}>
            {
              salary_min != '' && (
                `${t('messageForm.from')} ${salary_min?.toLocaleString('uk-UA')}`
              )
            }
            {
              salary_max != '' && (
                ` ${t('messageForm.to')} ${salary_max?.toLocaleString('uk-UA')}`
              )
            }
            {
              (salary_min != '' || salary_max != '') && (
                ` ${currencies[salary_currency]}/${t('messageForm.jobCardMonth')}`
              )
            }
          </div>
          <div className='JcardBodySection2 flex-row'>
            <div className='section2Item1'>
              {t('messageForm.jobCardExperience')}: {min_exp}{' '}
              {t('messageForm.jobCardYears')}
            </div>
            <div className='section2Item1'>
              {work_type}
            </div>
          </div>
          <h6 className='card-footer JcardFooter'>
            <div className='d-flex align-items-center'>
              <div className='me-2 JcardFooterItem1DynamicImage'>
                <img
                  alt='logo'
                  id='jobcard-company-logo'
                  src={
                    logo === 'https://dev.grc.com.ua/job-board-script/public/files/user/employer/' || !logo
                      ? '/Images/jobseekerSide/dummy-profile.png'
                      : logo
                  }
                />
              </div>
              <div className='JcardFooterItem2'>
                <h6 id='jobcard-company-name' title={company_name}>{company_name}</h6>
                <p id='jobcard-location' className='text-muted' title={job_city}>
                  <i id='jobcard-location-icon' className='fa-solid fa-location-dot' style={{ color: '#a3a3a3' }} />
                  {' '}
                  {job_city}
                </p>
              </div>
            </div>
            <div className='JcardFooterItem3'>
              <div className='section2Item2'>
                <i className='fa-regular fa-calendar-days' />{' '}
                {created}{' '}
                {t('messageForm.jobCardDaysAgo')}
              </div>
              {
                !userType
                  ? (
                    <button
                      className='btn button1 mt-0'
                      onClick={e => {
                        e.stopPropagation();
                        setOpenApplyJobModal(true);
                      }}
                    >
                      {t('jobDescription.applyNow')}
                    </button>
                  )
                  : ''
              }
              {
                userType === 'candidate'
                  ? (
                    is_applied === 1
                      ? (
                        <button
                          disabled
                          className='btn button1 mt-0'
                          onClick={e => e.stopPropagation()}
                        >
                          {t('jobDescription.applied')}
                        </button>
                      )
                      : (
                        <button
                          type='button'
                          className='btn button1 mt-0'
                          onClick={e => {
                            e.stopPropagation();
                            setOpenApplyJobModal(true);
                          }}
                        >
                          {t('jobDescription.applyNow')}
                        </button>
                      )
                  )
                  : ''
              }
            </div>
          </h6>
        </div>
      </div>

      <ApplyJobProvider>
        <ApplyJobModal
          jobId={jobId}
          jobTitle={title}
          onlyResume={onlyResume}
          open={openApplyJobModal}
          onlyQuestionnaire={onlyQuestionnaire}
          onClose={() => {
            setOpenApplyJobModal(false);
            getData();
          }}
          stepFrom={userType === 'candidate' ? 'jobApplySelect' : 'checkUser'}
        />
        </ApplyJobProvider> 
      
    </>
  );
};

export default JobCard;
